module.exports = __webpack_public_path__ + "internal-feedback-hero-b8fd6608f9993088be0761b4d9ef0f04.webp";